import React from "react";
import { DualAxes } from "@ant-design/plots";
import util from "../../utils/functions/custom";

const DualAxesChart = ({ data, }) => {

  const output = util.calculateRetention(data);
  console.log("Dataaaaaa", output)

  const config = {
    xField: 'year',
    children: [
      {
        data: output?.mainData,
        type: 'interval',
        yField: 'value',
        stack: true,
        colorField: 'type',
        style: { maxWidth: 80 },
        scale: { y: { domainMax: 1200 } },
        interaction: { elementHighlightByColor: { background: true } },
      },
      {
        data: output?.retentionData,
        type: 'line',
        yField: 'Retention % (end of year)',
        colorField: () => 'Retention % (end of year)',
        style: { lineWidth: 2 },
        axis: { y: { position: 'right' } },
        interaction: {
          tooltip: {
            crosshairs: false,
            marker: false,
          },
        },
        legend: {
          color: {
            title: false,
            position: 'bottom',
            rowPadding: 5,
          },
        },
      },
    ],
  };

  return <DualAxes {...config} />;
};

export default DualAxesChart;
